import { PaymentService } from "../payment/payment-service";

export function initCourseCheckoutPage(paymentService: PaymentService): void {
    // Wire invoice button -> payment service method
    const invoiceBtn = document.getElementById("invoiceButton") as HTMLElement | null;
    if (invoiceBtn) {
        invoiceBtn.setAttribute("type", "button"); // hard guarantee
        invoiceBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (!paymentService || typeof paymentService.submitCourseInvoiceFromButton !== "function") {
                console.error("[course-checkout] paymentService missing submitCourseInvoiceFromButton");
                return;
            }

            paymentService.submitCourseInvoiceFromButton(invoiceBtn);
        });
    }

    const poInput = document.getElementById("PoNumber") as HTMLInputElement | null;
    const poError = document.getElementById("PoNumberError") as HTMLElement | null;

    if (poInput) {
        poInput.addEventListener("input", () => {
            if (poInput.value.trim().length) {
                poInput.classList.remove("input-validation-error");
                if (poError) {
                    poError.textContent = "";
                    poError.classList.add("d-none");
                }
            }
        });
    }
}
